import PersistentWebSocket from "./persistentWebSocket"
import {getToken} from "./skylineApi"

let adminFeedWs

const allType = '-all-'

export const entityTypes = [
  allType, 'mission', 'device'
]

const callbacks = {}

for (const type of entityTypes) {
  callbacks[type] = {}
}

export function register(type, id, callback) {
  [type, id, callback] = standardizeInputs(type, id, callback)

  callbacks[type][id].push(callback)
}

export function unregister(type, id, callback) {
  [type, id, callback] = standardizeInputs(type, id, callback)

  const i = callbacks[type][id].indexOf(callback)
  if (i >= 0) {
    callbacks[type][id].splice(i, 1)
  }
}

function standardizeInputs(type, id, callback) {
  if (typeof type === 'function') {
    callback = type
    type = allType
    id = 0
  } else if (typeof id === 'function') {
    callback = id
    id = 0
  }

  const parsedId = parseInt(id)

  console.assert(entityTypes.includes(type), 'Invalid entity type: ' + type)
  console.assert(!isNaN(parsedId), 'Invalid id: ' + id)
  console.assert(typeof callback === 'function', 'callback is not a function')

  callbacks[type][id] = callbacks[type][id] || []

  return [type, id, callback]
}

function handleAdminFeedMessage(event) {
  if (!event.detail) {
    console.error("Received an invalid admin feed websocket event:", event)
    return
  }

  let message
  try {
    message = JSON.parse(event.detail)
  } catch (err) {
    console.error("Error parsing JSON on admin feed: ", err)
    return
  }
  
  const type = message.entityType
  const id = (message[message.entityType] && message[message.entityType].id) || 0

  const cbs = [].concat(
    callbacks[allType][0],
    callbacks[type][0],
    callbacks[type][id],
  )

  for (const callback of cbs) {
    if (callback) {
      callback(message)
    }
  }
}

export async function connect(baseUrl) {
  console.assert(baseUrl, "No admin feed URL was supplied when attempting to connect.")
  
  let adminFeedUrl = (window.location.protocol === "https:" ? "wss://" : "ws://") + baseUrl + "/feed"

  console.log("Admin feed is connecting...")
  adminFeedWs = new PersistentWebSocket(async () => adminFeedUrl + "?token=" + await getToken())
  adminFeedWs.connect()
  adminFeedWs.addEventListener("message", handleAdminFeedMessage)
}